// features/item-filter/scopeParams.js
//
// Scope slot (camelCase, the app's own vocabulary — `useGridChartScope`,
// `filterScope`) → backend query param. THE one place the wire names of the
// item scope are written: the grids, their exports and the timeline charts
// all translate through here, so a grid and the chart beside it cannot send
// the same filter under two names.

const SCOPE_PARAM_NAMES = {
  productCategoryId: 'product_category_id',
  // One picked item, or a drilled-down row (backend `api.item_scope.ItemScope`).
  itemCode: 'item_code',
  locationCode: 'location_code',
  // Free text, wildcard semantics (`core.utils.item_search_q`).
  search: 'search',
  // "Only items with active or scheduled promotions" (backend
  // `forecasting.views._promoted_only`).
  hasPromotions: 'has_promotions',
};

/**
 * Translate a scope into query params. Empty slots are omitted rather than
 * sent blank — the backends treat an absent filter and an empty one
 * identically, and omitting keeps a TanStack query key stable across
 * "no filter" renders.
 *
 * Unknown keys throw. A scope slot the endpoints don't understand is a
 * silently-ignored filter, i.e. a chart that disagrees with the grid next to
 * it — the failure mode this table exists to prevent.
 */
export function scopeParams(scope = {}) {
  const params = {};
  for (const [key, value] of Object.entries(scope)) {
    const wireName = SCOPE_PARAM_NAMES[key];
    if (!wireName) {
      throw new Error(
        `scopeParams: unknown scope key '${key}'. `
        + `Known keys: ${Object.keys(SCOPE_PARAM_NAMES).join(', ')}.`,
      );
    }
    if (value) params[wireName] = value;
  }
  return params;
}
